import {
    ConditionItem,
    Dictionary,
    EdgeDefinition,
    validationsMessages,
} from '../../lib';

export interface EdgeDefinitionType {
    id: string;
    name: string;
    fromDictionary: string;
    toDictionary: string;
    condition: ConditionItem[];
}

export type Column = {
    field: string;
    headerName: string;
    editable: boolean;
    flex: number;
    width?: number;
    headerClassName: string;
};

export const getColumns = (): Column[] => {
    return [
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
        },

        {
            field: 'fromDictionary',
            headerName: 'From',
            editable: false,
            flex: 2,
            headerClassName: 'dictionary-grid-header',
        },
        {
            field: 'toDictionary',
            headerName: 'To',
            editable: false,
            flex: 2,
            headerClassName: 'dictionary-grid-header',
        },
    ];
};

export interface AttributeAssociation {
    leftSideValue: string;
    rightSideValue: string;
}

export interface AttributeAssociationItem {
    attributeAssociation: AttributeAssociation;
    leftSideError: boolean;
    leftSideErrorMessage: string;
    rightSideError: boolean;
    rightSideErrorMessage: string;
    id: string;
}

export const defaultEdgeDefinition: EdgeDefinition = {
    fromDictionary: '',
    toDictionary: '',
    name: '',
    condition: [],
};

export const defaultAttributeAssociationItem: AttributeAssociationItem = {
    attributeAssociation: {
        leftSideValue: '',
        rightSideValue: '',
    },
    leftSideError: false,
    leftSideErrorMessage: '',
    rightSideError: false,
    rightSideErrorMessage: '',
    id: '',
};

export const defaultAttributeAssociationList: AttributeAssociationItem[] = [
    defaultAttributeAssociationItem,
];

export const EDGE_CONDITION_ERRORS = {
    EMPTY_CONDITION: 'At least one attribute association is required.',
    DUPLICATE_CONDITION:
        'Unable to add duplicated condition. Please select a different edge condition.',
};

export const getSortedDictionaryAttributesFor = (
    dictionaryName: string,
    dictionaries: Dictionary[]
): string[] => {
    const dictionaryFound = dictionaries.find(
        (currentDictionary) => currentDictionary.name === dictionaryName
    );
    const attributes = dictionaryFound?.attributes ?? [];

    if (!attributes.length) return [];

    const sortedAttributes =
        [...attributes].sort((a: any, b: any) => {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        }) ?? [];

    return sortedAttributes.map((attribute) => attribute.name);
};

const isFirstItemAndBothEmptyError = (
    isFirstItem: boolean,
    displayBothEmptyError: boolean
): boolean => {
    return isFirstItem && displayBothEmptyError;
};

const isSingleErrorForNonFirstItems = (
    isFirstItem: boolean,
    displayBothEmptyError: boolean,
    displaySingleSideError: boolean
): boolean => {
    return (
        (isFirstItem && !displayBothEmptyError && displaySingleSideError) ||
        (!isFirstItem && displaySingleSideError)
    );
};

export const getEmptyErrorMessage = (
    isFirstItem: boolean,
    displayBothEmptyError: boolean,
    displaySingleSideError: boolean
): string => {
    if (isFirstItemAndBothEmptyError(isFirstItem, displayBothEmptyError)) {
        return EDGE_CONDITION_ERRORS.EMPTY_CONDITION;
    } else if (
        isSingleErrorForNonFirstItems(
            isFirstItem,
            displayBothEmptyError,
            displaySingleSideError
        )
    ) {
        return validationsMessages.required;
    }
    return '';
};
